import React from "react";
import MyGroupsNav from "../../Groups/groupPageComponents/MyGroupsNav";
import RelevantGroupsRecommendation from "../../Groups/groupPageComponents/RelevantGroups";

/**
 * Replaces the old, single always-render <MyGroupsNav variant="strip" />
 * slot with a state-aware choice, per the flow/psychology review of this
 * page (see chat history around 2026-08-30, "are we not a marketplace for
 * credibility" thread): a brand-new user with zero owned groups used to see
 * this whole slot render nothing (MyGroupsNav's own empty check), and the
 * one surface that could actually convert them -- RelevantGroups,
 * "groups related to your watchlist" -- was buried far down the page inside
 * ConsolidatedSocialSection. Both components already existed and were
 * already fully built and wired; the fix is which one occupies this
 * high-visibility slot, not new UI.
 *
 * Group owners still see the fast, familiar jump-to-my-groups strip
 * (unchanged from before). Non-owners now see a real, specific invitation
 * (named groups discussing their actual watchlist tickers) at the moment
 * the page would otherwise have shown nothing at all -- asking someone to
 * join something that already exists is a lower-commitment first action
 * than asking them to create a group from a blank slate.
 */
const GroupsQuickAccess = ({ groups = [], relevantGroups = [], currentUser }) => {
  const ownsAnyGroup = groups.some(
    (g) => !!currentUser?.id && (g?.created_by === currentUser.id || g?.createdBy?.id === currentUser.id)
  );

  if (ownsAnyGroup) {
    return <MyGroupsNav groups={groups} currentUser={currentUser} variant="strip" />;
  }

  if (!relevantGroups.length) return null;

  return (
    <div className="mb-4 sm:mb-6">
      <RelevantGroupsRecommendation groups={relevantGroups} />
    </div>
  );
};

export default GroupsQuickAccess;
